import { Directive } from 'vue'

const map = new WeakMap()
const ob = new ResizeObserver((entries) => {
  for (const entry of entries) {
    const handler = map.get(entry.target)
    if (handler) {
      handler({
        width: entry.borderBoxSize[0].inlineSize,
        height: entry.borderBoxSize[0].blockSize,
      })
    }
  }
})

const ResizeOb: Directive<HTMLElement, (e: MouseEvent) => any> = {
  mounted(el, binding) {
    map.set(el, binding.value)
    ob.observe(el)
  },
  beforeUnmount(el) {
    ob.unobserve(el)
  },
}

export default {
  name: 'resize-ob',
  definition: ResizeOb,
}
